module.exports = __webpack_public_path__ + "static/media/Review-Details.1a070e40.png";